import React from 'react';
import {connect} from 'react-redux';
import {BrowserRouter, Redirect, Route, Switch, useRouteMatch} from "react-router-dom";
import {useStyletron} from 'styletron-react';
import {setUserDataLoading} from './actions/ui';
import {loadUserData} from './actions/userData';
import ReinstateSubscription from './billing/ReinstateSubscription';
import RecoverableError from './components/error/RecoverableError';
import {UnrecoverableError} from './components/error/UnrecoverableError';
import {ADMIN_PAGE_LINK, PROFILE_LINK} from './components/flows/linkConstants';
import LoadingScreen from './components/LoadingScreen';
import ResetPassword from './components/login/ResetPassword';
import ToolBar from './components/Toolbar';
import {AuthUserContext, withAuthentication} from './firebase/session';
import {AdminPage} from './pages/AdminPage';
import Profile from './pages/AppPage';
import LoginPage from './pages/LoginPage';
import {Logout} from "./pages/LogoutPage";
import firebase from "firebase";


const NavigatedApp = () => {
  let { authUser } = React.useContext(AuthUserContext);

  if (authUser === undefined) {
    return <LoadingScreen />
  } else if (authUser !== undefined && (authUser === null || !authUser.email)) {
    return <BrowserRouter>
      <Switch>
        <Route exact path="/" component={LoginPage} />
        <Route exact path="/logout" component={Logout} />
        <Route path="/reset-password" component={ResetPassword} />
        <Redirect to='/' />
      </Switch>
    </BrowserRouter>
  }

  const { paid } = authUser.claims;
  if (!paid) {
    return <BrowserRouter>
      <Switch>
        <Route exact path="/logout" component={Logout} />
        <Route path='/purchase' component={ReinstateSubscription} />
        <Redirect to='/purchase' />
      </Switch>
    </BrowserRouter>
  }

  return <BrowserRouter>
    <Switch>
      <Route path={ADMIN_PAGE_LINK} component={AdminPage} />
      <Route exact path="/logout" component={Logout} />
      <Route path="/app" component={FirebaseApp} />
      <Redirect to={PROFILE_LINK} />
    </Switch>
  </BrowserRouter>
}

const App = ({ userDataLoading, setUserDataLoading, loadUserData, error }) => {
  const [css] = useStyletron();
  const match = useRouteMatch();

  let { authUser } = React.useContext(AuthUserContext);
  React.useEffect(() => {
    loadUserData(authUser);
  }, [userDataLoading, authUser, setUserDataLoading, loadUserData]);

  return (
      <div className={css({ width: "100vw", height: "100vh", margin: 0 })}>
        <Route path={`${match.path}/:tab`}>
          {userDataLoading ?
              <LoadingScreen /> :
              <>
                <ToolBar />
                {error === 'irrecoverable' ? <UnrecoverableError /> : <Profile />}
                <RecoverableError />
              </>}
        </Route>
      </div>
  );
}

const FirebaseApp = connect(state => ({
  userDataLoading: state.ui.loading,
  error: state.ui.error
}), {
  setUserDataLoading,
  loadUserData
})(App);

export default withAuthentication(NavigatedApp);
